<template>
  <div>
    <van-row :gutter="10">
      <van-col :span="6">
        <div
          :class="{'form-box-tag':true,'active':currentIndex==0 ? true:false}"
          @click="swap(0)"
        >随时入住</div>
      </van-col>
      <van-col :span="18">
        <div
          :class="{'form-box-tag':true,'active':currentIndex==1 ? true:false}"
          @click="swap(1)"
        >{{txt}}</div>
      </van-col>
    </van-row>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="getDate"
        @cancel="showPicker=false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Row, Col, Tag, DatetimePicker, Popup } from "vant";

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup
  },

  data() {
    return {
      isactive: true,
      showPicker: false,
      currentIndex: -1,
      txt: "选择入住时间",
      currentDate: new Date()
    };
  },
  props: {},
  mounted() {
 
  },

  methods: {
    swap(index) {
      this.currentIndex = index;
      if (index == 0) {
        this.$emit("change", { isintime: 1, intime: "" });
      }
      if (index == 1) {
        this.showPicker = true;
      }
      //
    },
    getDate(value) {
      this.txt = this.dateFormatter(value);
      this.showPicker = false;
      this.$emit("change", { isintime: 0, intime: this.txt });
    },
    dateFormatter(date) {
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const strDate = date
        .getDate()
        .toString()
        .padStart(2, "0");
      return `${date.getFullYear()}-${month}-${strDate}`;
    }
  }
};
</script>

<style scoped>
.form-box-tag {
  background-color: #f8f8f8;
  line-height: 32px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
}
.form-box-tag.active {
  background-color: #feefe9;
  color: #f56229;
}
</style>>



